import { postCreateCodeCountry } from '../api/postCreateCodeCountry';
import { putCodeCountry } from '../api/putCodeCountry';
import { getListCodeCountry } from '../api/getListCodeCountry';
import { setGetListCodeCountry } from './setGetListCodeCountry';

export const setPutCodeCountry = (params) => {
    return async (dispatch, getState) => {
        try {
            await putCodeCountry(params);
            dispatch(setGetListCodeCountry());
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}